/*!
 * Copyright (c) 2018 Digital Bazaar, Inc. All rights reserved.
 */
'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _get = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var ControllerProofPurpose = require('./ControllerProofPurpose');

module.exports = /*#__PURE__*/function (_ControllerProofPurpo) {
  _inherits(AuthenticationProofPurpose, _ControllerProofPurpo);

  function AuthenticationProofPurpose() {
    var _this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$term = _ref.term,
        term = _ref$term === void 0 ? 'authentication' : _ref$term,
        controller = _ref.controller,
        challenge = _ref.challenge,
        date = _ref.date,
        domain = _ref.domain,
        _ref$maxTimestampDelt = _ref.maxTimestampDelta,
        maxTimestampDelta = _ref$maxTimestampDelt === void 0 ? Infinity : _ref$maxTimestampDelt;

    _classCallCheck(this, AuthenticationProofPurpose);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AuthenticationProofPurpose).call(this, {
      term: term,
      controller: controller,
      date: date,
      maxTimestampDelta: maxTimestampDelta
    }));

    if (typeof challenge !== 'string') {
      throw new TypeError('"challenge" must be a string.');
    }

    if (domain !== undefined && typeof domain !== 'string') {
      throw new TypeError('"domain" must be a string.');
    }

    _this.challenge = challenge;
    _this.domain = domain;
    return _this;
  }

  _createClass(AuthenticationProofPurpose, [{
    key: "validate",
    value: function () {
      var _validate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(proof, _ref2) {
        var verificationMethod, documentLoader, expansionMap;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                verificationMethod = _ref2.verificationMethod, documentLoader = _ref2.documentLoader, expansionMap = _ref2.expansionMap;
                _context.prev = 1;

                if (!(proof.challenge !== this.challenge)) {
                  _context.next = 4;
                  break;
                }

                throw new Error('The challenge is not as expected; ' + "challenge=\"".concat(proof.challenge, "\", expected=\"").concat(this.challenge, "\""));

              case 4:
                if (!(this.domain !== undefined && proof.domain !== this.domain)) {
                  _context.next = 6;
                  break;
                }

                throw new Error('The domain is not as expected; ' + "domain=\"".concat(proof.domain, "\", expected=\"").concat(this.domain, "\""));

              case 6:
                return _context.abrupt("return", _get(_getPrototypeOf(AuthenticationProofPurpose.prototype), "validate", this).call(this, proof, {
                  verificationMethod: verificationMethod,
                  documentLoader: documentLoader,
                  expansionMap: expansionMap
                }));

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](1);
                return _context.abrupt("return", {
                  valid: false,
                  error: _context.t0
                });

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 9]]);
      }));

      function validate(_x, _x2) {
        return _validate.apply(this, arguments);
      }

      return validate;
    }()
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(proof, _ref3) {
        var document, suite, documentLoader, expansionMap;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                document = _ref3.document, suite = _ref3.suite, documentLoader = _ref3.documentLoader, expansionMap = _ref3.expansionMap;
                _context2.next = 3;
                return _get(_getPrototypeOf(AuthenticationProofPurpose.prototype), "update", this).call(this, proof, {
                  document: document,
                  suite: suite,
                  documentLoader: documentLoader,
                  expansionMap: expansionMap
                });

              case 3:
                proof = _context2.sent;
                proof.challenge = this.challenge;

                if (this.domain !== undefined) {
                  proof.domain = this.domain;
                }

                return _context2.abrupt("return", proof);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function update(_x3, _x4) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }]);

  return AuthenticationProofPurpose;
}(ControllerProofPurpose);